import { useLayoutEffect, useRef } from 'react';
import IconSvg from 'Components/IconSvg';

const Toast = ({ onDismiss, toast = {} }) => {
  const handleDismiss = () => onDismiss(toast.id);
  const toastRef = useRef(null);

  // Set progress animation duration based on toast duration
  // Default duration of 5s set in withToaster dispatch method
  useLayoutEffect(() => {
    const toastProgressIcon = toastRef.current.querySelector(
      '.toaster__toast-progress .close-progress__outer-overlay'
    );
    if (toastProgressIcon)
      toastProgressIcon.style.animationDuration = `${toast.duration / 1000}s`;
  }, []);

  return (
    <div className="toaster__toast" ref={toastRef}>
      <span>{toast.message}</span>
      <button className="toaster__toast-dismiss" onClick={handleDismiss}>
        <IconSvg className="toaster__toast-progress" type="closeProgress" />
      </button>
    </div>
  );
};

export default Toast;
